<template>
  <div class="englarge-image__wrapper" :class="{'mt-0': image && error}">
    <div class="enlarge-image__content">
      <img
        v-show="image && !error && !isLoadingImage"
        :src="image"
        class="enlarge-image__image"
        @error="onImageError()"
        @load="onImageLoaded()"
      >
      <div class="image__loading" v-if="isLoadingImage">
        <aha-spinner
          size="md"
          variant="tail"
        />
      </div>
      <div
        class="enlarge-image__button"
        @click.stop="openImage($event, image)"
        v-if="image && !error && !isLoadingImage"
      >
        <img src="@/assets/images/icon/enlarge-image.png" alt="" width="24">
      </div>
      <aha-icon name="image" class="text-secondary-20" v-if="image && error && !isLoadingImage" />
    </div>
  </div>
</template>

<script>
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'

export default {
  props: {
    image: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      error: false,
      isLoadingImage: true,
    }
  },
  methods: {
    openImage(event, img) {
      event.stopPropagation()
      const pswpElement = document.querySelectorAll('.pswp')[0]

      const items = []
      items.push({
        src: img,
        w: -1,
        h: -1,
        title: '',
      })
      // define options (if needed)
      const options = {
        // disable photoswipe from modifying history, avoid conflict with back to last slide
        history: false,
        index: 0, // start at first slide
        fullscreenEl: false,
      }

      // Initializes and opens PhotoSwipe
      const gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUIDefault,
        items,
        options,
      )

      // $(".pswp__item").addClass("img-none");

      gallery.listen('imageLoadComplete', (index, item) => {
        if (item.w < 1 || item.h < 1) {
          const imgObj = new Image()
          imgObj.src = item.src
          imgObj.onload = function loadingImage() {
            item.w = imgObj.width
            item.h = imgObj.height
            gallery.invalidateCurrItems()
            gallery.updateSize(true)
          }
        }
      })

      gallery.listen('close', () => {
      })

      gallery.init()
    },
    onImageLoaded() {
      this.isLoadingImage = false
    },
    onImageError() {
      this.error = true
      this.isLoadingImage = false
    },
  },
}
</script>

<style lang="scss" scoped>
.enlarge-image__button {
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
  z-index: 10;
}
.englarge-image__wrapper {
  @apply w-full flex justify-center;
  .enlarge-image__content {
    @apply relative w-max;
    max-width: 96%;;
  }
}
.image__loading {
  // Overwrite bootstrap flex in canvas
  ::v-deep.flex {
    flex: unset;
    display: flex;
  }
}
</style>
